import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const masterdataRoutes = ({
  WarrantyReminder,
  AddUpdate,
  EditUpdate,
  // =================================================================
  UnfollowRemind,
  AddUnfollowRemind,

  // =================================================================
  WarrantyTimeRemind
}: {
  // Quản lý nội dung
  WarrantyReminder: React.ComponentType;
  AddUpdate: React.ComponentType;
  EditUpdate: React.ComponentType;
  // =================================================================
  UnfollowRemind: React.ComponentType;
  AddUnfollowRemind: React.ComponentType;
  // =================================================================
  WarrantyTimeRemind: React.ComponentType;
}) => (
  <Routes>
    {/* Gửi tin nhắn nhắc nhở bảo hành - Cấu hình thời gian nhắc nhở */}
    <Route path={ROUTES.MASTER_DATA.WARRANTY_REMINDER.BASE} element={<WarrantyReminder />} />
    <Route path={ROUTES.MASTER_DATA.WARRANTY_REMINDER.CREATE.BASE} element={<AddUpdate />} />
    <Route path={ROUTES.MASTER_DATA.WARRANTY_REMINDER.DETAIL.BASE} element={<EditUpdate />} />

    {/* Remind bỏ theo dõi */}
    <Route path={ROUTES.MASTER_DATA.UNFOLLOW_REMIND.BASE} element={<UnfollowRemind />} />
    <Route path={ROUTES.MASTER_DATA.UNFOLLOW_REMIND.CREATE.BASE} element={<AddUnfollowRemind />} />

    {/* Nhắc nhở lịch bảo hành */}
    <Route path={ROUTES.MASTER_DATA.WARRANTY_TIME_REMIND.BASE} element={<WarrantyTimeRemind />} />
  </Routes>
);
